import { LOCALES } from "../locales";

export default {
  [LOCALES.JAPANESE]: {
    // general product translation
    January: "1",
    February: "2",
    March: "3",
    April: "4",
    May: "5",
    June: "6",
    July: "7",
    August: "8",
    September: "9",
    October: "10",
    November: "11",
    December: "12",

    class_policy: "クラスのポリシー",
    Faq: "FAQs",
    help: "ヘルプ",
    frequently_asked_ques: "よくある質問",
    customer_support: "カスタマーサポート",
    user_name: "ユーザー名",
    password: "パスワード",
    email_address: "E メールアドレス",
    // Header Translations
    notification: "お知らせ",
    page_loading_aria: "ページを読み込んでいます",
    state_loading_aria: "州/地域を読み込んでいます",
    city_loading_aria: "市を読み込んでいます",
    badge_placeholder: "Badge placeholder",
    badge_overall: "全バッジ",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "証書画像",
    certificate_download: "証書ダウンロードボタン",
    prev: "前へ戻る",
    log_out: "ログアウト",
    // feature names
    feature_progress: "学習進捗状況",
    feature_stressAndIntonation_title: "強調とイントネーション",
    feature_soundOfEnglish_title: "英語の音",
    feature_vocabularyCenter_title: "ボキャブラリセンター",
    feature_grammarCenter_title: "文法センター",
    feature_culture_centre_title: "異文化情報",
    feature_globalCommunityTutorials_title: "グローバルコミュニティチュートリアル",
    feature_industryfeed_title: "インダストリーフィード",
    feature_newsfeed_title: "ニュースフィード",
    feature_emailTemplates_title: "E メールテンプレート",
    feature_talkWithTeacher_title: "Talk with teacher",
    feature_accentsAndDialects_title: "アクセントと方言",
    feature_writingCenter_title: "ライティング センター",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "会社概要",
    legal: "法律条項",
    privacy_policy: "プライバシー ポリシー",
    Terms_conditions: "使用条件",
    //button translations
    button_continue: "続行",
    button_KnowMore: "詳細を表示",
    button_BuyNow: "今すぐ購入",
    button_Subscribe: "購読する",
    button_GetStarted: "開始する",
    button_view: "View",
    button_GoText: "Go",
    button_Resume: "Continue learning",
    button_ViewDetails: "詳細",
    button_ContinueStudying: "続ける",
    button_next: "次へ",
    button_confirm: "確認する",
    // cookie policy
    common_cookiesPolicyText1:
      "Learnshipでは、最高のサービスを保証するためにクッキーを使用しています。このサイトを利用することで、お客様はクッキーの使用に同意したことになります。",
    common_cookiesPolicyText2: "クッキーの使用に",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "ようこそ",
    login_heloo: "おかえりなさい",
    login_welcome_text: "さあ始めましょう",
    login_log_in: "ログイン",
    login_errorIncorrectCreds: "ユーザー名またはパスワードが正しくありません。",
    login_errorContactAmin: "アカウントが無効になっています。 管理者にお問い合わせください。",
    login_errorSSOuser: "貴社の学習ポータルからログインする必要があります。",
    login_forgotPassword: "パスワードをお忘れですか。",
    login_resetPasswordTitle: "パスワードのリセット",
    login_resetSuccess: "パスワードのリセットに必要なリンクをEメールにてお送りいたしました。",
    login_resetFailure: "E メールアドレスが正しくありません。",
    // common translations
    message_errorDefault: "エラーが発生しました",
    message_successUpdated: "更新が完了しました",
    message_unknownError: "Unknown error",
    message_unAuthorized: "アクセス許可が必要です",
    message_passwordUpdated: "パスワードの更新が完了しました",
    message_profileUpdated: "プロフィールの更新が完了しました",
    message_welcomeSubmitted: "正常に送信された情報",
    message_samepasswordError:
      "新しいパスワードを入力してください。すでに使用されているパスワードではないことを確認してください。",
    SAR: "地域を選択",
    SAL: "場所を選択",
    SAT: "トピックを選択",
    link_readmore: "詳細情報",
    //--//
    profile_title: "プロフィール",
    profile_nameLabel: "氏名： ",
    profile_countryLabel: "国",
    profile_stateLabel: "都道府県",
    profile_cityLabel: "市町村",
    profile_emailLabel: "Eメール",
    profile_prefContactLabel: "ご希望の連絡方法",
    profile_prefSkypeLabel: "Skype（個人）ID",
    profile_prefMobileLabel: "携帯電話番号",
    profile_prefLandlineLabel: "固定電話番号",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "契約条件に同意する",
    profile_continueAria: "続行ボタン",
    profile_TermsAria: "利用規約に同意します",
    profile_stateTooltip: "オンラインセッションをスケジュールするためのタイムゾーンの設定に必要となります。",
    profile_cityTooltip: "このなかの市町村のどちらにもお住まいでない場合、最も近い所をお選びください。",
    profile_emailTooltip: "Eメールアドレスを認証してください",
    profile_prefTooltip:
      "オンボーディング過程で別の連絡方法をご指定になった場合でも、セッションはすべてバーチャルクラスルームで行われます。ご希望の連絡方法は、お客様の学習体験を継続的にお手伝いするため、社内利用の目的でのみお伺いしております。",
    profile_fnamePlaceholder: "名",
    profile_lnamePlaceholder: "姓",
    profile_countryPlaceholder: "国を選択してください",
    profile_prefContactSelect: "ご希望のものを選択してください",
    profile_statePlaceholder: "都道府県を選択してください",
    profile_cityPlaceholder: "市町村を選択してください",
    profile_emailInvalidMessage: "Eメールアドレスが無効です",
    profile_prefContactPlaceholder: "ご希望のものを選択してください",
    profile_prefSkypePlaceholder: "Skype（個人）",
    profile_emailVerifiedChip: "確認済み",
    profile_emailVerifyChip: "承認",
    profile_emailpopup_head: "認証コードを入力します",
    profile_emailpopup_codePlaceholder: "コード",
    profile_emailpopup_resendText: "コードを再送します",
    profile_emailpopup_resendMessage: "コードを受信できませんでしたか？",
    profile_invalidNumber: "無効な番号",
    profile_prefSkypeAria: "Skype（個人）IDを希望の連絡方法とします",
    profile_prefMobileAria: "携帯電話を希望の連絡方法とします",
    profile_prefLandlineAria: "固定電話を希望の連絡方法とします",
    profile_emailpopup_incorrectCode: "無効なコード",
    profile_editLabel: "プロフィールを編集",
    profile_editAria: "編集",
    profile_mainPasswordPlaceholder: "パスワードをこちらに入力",
    profile_updateLabel: "アップデート",
    profile_welcomeJumbotron: "ご自身についてお答えください。",
    profile_cancelLabel: "キャンセル",
    noAccessl1: "申し訳ありません、受講者の皆様にはこちらのページの閲覧が許可されていません。",
    noAccessl2: "ホームページに戻るリンクはこちら",
    noAccessl2_1: "homepage",
    noAccessl3: "受講者の皆様のLearnship管理者にご相談ください。",
    profile_license_information: "License information",
    profile_license_message: "ライセンスの有効期限",
    profile_changepass_changepassHead: "パスワードの変更",
    profile_changepass_currentpassword: "現在のパスワード",
    profile_changepass_currentpasswordPlaceholder: "現在のパスワードを入力",
    profile_changepass_newpassword: "新しいパスワード",
    profile_changepass_newpasswordPlaceholder: "新しいパスワードを入力",
    profile_changepass_confirmnewpassword: "新しいパスワードを認証する",
    profile_passMustInclude: "パスワードは以下の条件を満たしている必要があります。",
    profile_passdontmatch: "パスワードが一致しません",
    profile_incorrectPassword: "パスワードが間違っています",
    profile_passwordSubmit_title: "パスワードの入力",
    profile_changepass_conditionLength: "8文字以上32文字以内",
    profile_changepass_conditionUppercase: "少なくとも大文字1つ",
    profile_changepass_conditionLowercase: "少なくとも小文字1つ",
    profile_changepass_conditionSpecialCharacters: "少なくとも数字1つまたは$!#&@?%*_のシンボルの中から１つ",
    profile_translationLanguage: "翻訳",
    profile_translationLanguagePlaceholder: "言語の選択",
    profile_managerEmailPlaceholder: "マネジャーのEメール",
    profile_managerEmailpopupPlaceholder: "管理者Eメールアドレス",
    // Learner Home Page translations
    learnerhome_survey_header: "ご意見をお聞かせください",
    learnerhome_survey_line1: "私たちのサービスへのご意見・ご感想を貴社へお伝えください。",
    learnerhome_survey_line2: "アンケート終了日",
    learnerhome_survey_line3: "今後のサービス向上のために、あなたのフィードバックをお聞かせください。",
    learnerhome_survey_button1: "アンケートを開始する",
    learnerhome_survey_button2: "アンケートをスキップする",
    active_course: "ご利用いただけるコース",
    admin_header: "Administration",
    admin_dashboard_header: "Dashboard",
    get_startedText: "開始するには以下のコースをクリックしてください。",
    product_solo_desc:
      "弊社のeラーニング商品 Learnship Solo は、受講者の皆様が、ご自身のペースでビジネス言語のスキルを練習して上達することができるビジネス英語学習をご提供いたします。",
    product_conversationPractice_desc:
      "受講者の皆様は、質問やニーズに応じた学習内容、あるいはロールプレイの練習のために講師との１対１対面セッションをご予約いただけます。",
    product_sprint_businessSkills_desc:
      "こちらの次世代ブレンド型学習プログラムは、受講者の皆様がプレゼンテーション、交渉、ビジネス文書作成、ミーティング参加など、特定のビジネススキルを最短時間で上達させるお手伝いをいたします。",
    product_sprint_levelsProgress_desc:
      "弊社の次世代ブレンド型語学プログラムは、標準化されたフレームワークに沿って、受講者の皆様が英語スキルを迅速に向上させるのに役立ちます。",
    product_sprint_business_german_desc:
      "弊社の次世代ブレンド型語学プログラムは、標準化されたフレームワークに沿って、受講者の皆様がドイツ語スキルを迅速に向上させるのに役立ちます。",
    product_sprint_business_french_desc:
      "弊社の次世代ブレンド型語学プログラムは、標準化されたフレームワークに沿って、受講者の皆様がフランス語スキルを迅速に向上させるのに役立ちます。",
    product_sprint_business_spanish_desc:
      "弊社の次世代ブレンド型語学プログラムは、標準化されたフレームワークに沿って、受講者の皆様がスペイン語スキルを迅速に向上させるのに役立ちます。",
    product_evolve_relocationLanguage_desc:
      "弊社の、社員リロケーションプログラムは、受講者の皆様が新たな居住国においてその言語や文化のニュアンスに対し理解を深めるお手伝いをいたします。",
    product_evolve_culturePowerSkills_desc:
      "貴社の社員の皆様に、国際的な労働環境や国境を越えたチームで活躍するために必要な異文化スキルを学んでいただくことができます。",
    product_evolve_cultureFocus_desc:
      "特定の地域とそのワーキングカルチャーに対する理解が必要とされる受講者の皆様のためのそれぞれの国に特化したトレーニングとカルチュラル・インテリジェンス。",
    product_evolve_cultureChange_desc:
      "こちらは駐在員の皆様のためのプレミアインターカルチュラルビジネストレーニングです。受講者の皆様は、新しい文化に暮らし、働くということへの洞察的理解を学んでいただくことができます。",
    product_elevate_businessSkills_desc:
      "プレゼンテーション、交渉、チームでのリーダーシップなど、特定のビジネススキルを向上させたい語学受講者の皆様のための、短期の標準的なトレーニングモジュールです。",
    product_elevate_levelsProgress_desc:
      "こちらの講師主導のビジネス英語コースは、受講者の皆様が標準的な枠組みに沿って筆記・会話のスキルを向上させるお手伝いをいたします。",
    product_coach_languageCoach_desc:
      "役員会議で、Eメールで、交渉の場で、あるいは休憩室でも自信を持ってはっきりとコミュニケーションをとりましょう。弊社のプライベートのエグゼクティブクラスに特化した語学コーチングは、受講者の皆様が最も重要なビジネスシナリオを習得するお手伝いをいたします。",
    product_coach_cultureCoach_desc:
      "特定の異文化コミュニケーション問題を解決されることをお望みのエグゼクティブの方々が対象の、非常に特化された１対１対面コーチングプログラムです。",
    product_solo_business_english:
      "レベル別学習プログラムは、魅力的なオンライン演習を兼ね備え、自身のペースでビジネスのための英語の知識と応用力を身につけることができます。",
    product_solo_business_german:
      "レベル別学習プログラムは、魅力的なオンライン演習を兼ね備え、自身のペースでビジネスのためのドイツ語の知識と応用力を身につけることができます。",
    product_solo_business_french:
      "レベル別学習プログラムは、魅力的なオンライン演習を兼ね備え、自身のペースでビジネスのためのフランス語の知識と応用力を身につけることができます。",
    product_solo_business_spanish:
      "レベル別学習プログラムは、魅力的なオンライン演習を兼ね備え、自身のペースでビジネスのためのスペイン語の知識と応用力を身につけることができます。",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "こちらのページからDashboardにアクセスすることができます。Dashboardは、管理者が利用状況の追跡や学習者の進捗状況の分析、プログラムのオプティマイズやROIの評価などを行うことができる、直感的インターフェースです。",
    product_elevate_desc:
      "Elevate Business English は、個人講師と一緒に総合的な言語力を向上させたい学習者のための、対面型オンライン言語トレーニングです。",
    product_reach_desc:
      "Enhance your learning journey with personalized micro-modules and side missions focusing on real-world business skills.",
    product_lorem_solo_desc:
      "こちらの充実したマルチメディアプログラムは、標準化されたフレームワークに沿って貴社の社員の英語力を迅速に向上させるのに役立ちます。",
    //feature translations
    feature_cultureCentre_desc:
      "受講者の皆様のビジネスとプロフェッショナルライフにとって重要な地域の文化に馴染みましょう。",
    feature_emailTemplates_desc:
      "Eメールテンプレートは幅広いビジネス用途にて使えるように多くの種類のテンプレートをご用意しております。テンプレートに追記・変更をして、社内・社外へのEメールを送られる際にいただくことができます。",
    feature_newsFeed_desc:
      "弊社の革新的な世界ニュース体験へようこそ！　Learnshipのシステムによるライブコンテツと問題で英語を学びましょう。",
    feature_talkWithTeacher_desc:
      "This is for learners who want to apply their new skills in conversation. Users can join a virtual group classroom to practice their chosen language and take part in Q&As with speaking speacialists.",
    feature_industryFeed_desc:
      "業界フィードは業界特化の記事のライブラリをAIによる語学エクササイズと併合させます。練習されたい文法項目に沿って記事をお選びください。",
    feature_accentsAndDialects_desc:
      "様々な地域のスピーチサンプルを収集したライブラリーで、世界の英語の豊かな使い方を探ってみませんか。",
    feature_stressAndIntonation_desc:
      "会話時に正しい強調、リズム、イントネーションを用いることを学び、より自然で理解しやすい英語を身につけましょう。",
    feature_soundOfEnglish_desc: "英語の音の正しい発音を身につけ、コミュニケーションスキルを磨きましょう。",
    feature_vocabularyCenter_desc:
      "文法なくしてはほとんど伝わらない。語彙なくしてはまったく伝わらない。ーーデイヴィッド・ウィルキンス",
    feature_grammarCenter_desc:
      "文法センターは会話や文書作成において文法を正しく使いこなすお手伝いをいたします。基礎構文要素、動詞とその活用、文や節などの文法トピックが含まれます。",
    feature_globalCommunityTutorials_desc:
      "常に最新の、コミュニティで開発されたレッスンコレクションで英語スキルを磨きましょう。",
    feature_toeic_desc:
      "TOEIC®テストは社員の英語力を測るために多くの多国籍企業で採用されています。TOEIC®では、ビジネス英語スキルを診断するために実践的な文書や会話が用いられます。",
    feature_toefl_desc:
      "外国語としての英語のテスト、TOEFL®は、英語力を判定するために世界中のカレッジや大学、政府機関、奨学プログラムなどで採用されています。",
    feature_businessSituations_desc:
      "ビジネス・シチュエーション・インデックスで、様々なビジネスシーンにおいてコミュニケーションをとるために必要な言葉遣いを集中して学ぶための特定アクティビティを簡単にお探しいただけます。",
    //carousel block translations
    title_feature: "機能",
    we_recommend: "その他のおすすめサービス",
    // session report translations
    SessionReport_sessionReport: "セッションレポート",
    SessionReport_sessionDetails: "詳細",
    SessionReport_teacherName: "講師名",
    SessionReport_sessionReview: "セッションを復習する",
    SessionReport_sessionFeedback: "セッションのフィードバック",
    SessionReport_sessionMaterials_Assignments: "セッションで使用された教材と宿題",
    SessionReport_instructions: "説明",
    SessionReport_open: "開く",
    SessionReport_invalidSession_Message: "申し訳ありません、こちらのセッションのレポートはございません。",
    SessionReport_rateSession: "セッションを評価する",
    SessionReport_handouts: "Handouts",
    SessionReport_coachName: "とのセッションはいかがでしたか。",
    SessionRating_sessionDate: "セッションの日付",
    SessionRating_sessionTime: "セッションの時刻",
    SessionRating_sessionDuration: "セッションの期間",
    SessionRating_status: "ステータス",
    SessionRating_rateYourExperience: "受講したセッションを評価する",
    SessionRating_whatWentWrong: "何か問題がありましたか？",
    SessionRating_content: "内容",
    SessionRating_technology: "テクノロジー",
    SessionRating_comment: "コメントを入力する",
    SessionRating_submit: "提出",
    SessionRating_remindMeLater: "後で通知する",
    SessionRating_close: "閉じる",
    SessionRating_completed: "受講済",
    sessionRating_sessionDetails_mins: "分",
    // my schedule page translations
    myschedule_availability_abty_given:
      "現在、ご提出いただいたスケジュールに基づいて、講師とのスケジュール調整をしております。",
    myschedule_schedule: "スケジュール",
    myschedule_availability_needAvl: "セッションのスケジュールを調整するにあたって、受講可能日時のご提出が必要です。",
    myschedule_availability_abty_not_given: "受講可能日時を提出／変更する",
    myschedule_statusCard_completed: "受講したセッション数",
    myschedule_statusCard_remaining: "残りのセッション数",
    myschedule_statusCard_scheduled: "予約が必要なセッション数",
    myschedule_statusCard_lost: "無効なレッスン数（直前のキャンセル及び欠席）",
    myschedule_recentUpcoming_courseName: "コース名",
    myschedule_next_session: "次のセッション",
    myschedule_session_topic: "セッションのトピック",
    myschedule_sessionDetails_communication: "コミュニケーション",
    myschedule_sessionDetails_allSessions: "すべてのセッション",
    myschedule_sessionDetails_upcomingSessions: "次のセッション",
    myschedule_sessionDetails_pastSessions: "過去のセッション",
    myschedule_sessionDetails_teacher_name: "講師",
    myschedule_sessionDetails_sessions: "セッション数",
    myschedule_sessionDetails_date: "日付",
    myschedule_sessionDetails_time: "時間",
    myschedule_sessionDetails_durationText: "セッションの時間",
    myschedule_sessionDetails_min: "分",
    myschedule_reschedule_Title: "セッション再スケジュールの方法",
    myschedule_reschedule_InstrBegin: "こちらが講師とのセッションを再スケジュールする方法です。",
    myschedule_reschedule_instr1a: "画面上部でセッションの詳細を確認してください。",
    myschedule_reschedule_instr1b: "セッションの日時が上部に表示されています。",
    myschedule_reschedule_instr2: "講師のスケジュール可能日時は緑色で示されています。",
    myschedule_reschedule_instr3:
      "講師のスケジュール可能日時を閲覧することができます。スケジュール可能な時間枠は緑色で示されています。",
    myschedule_reschedule_instr4: "再スケジュールしたい時間枠をお選びください。",
    myschedule_reschedule_instr5:
      "再スケジュールするには、スケジュール可能な時間枠の中からご希望の時間の緑色の部分をクリックしてください。",
    myschedule_reschedule_next_instr1: "空いているスケジュールがありません。",
    myschedule_reschedule_next_instr2:
      "講師とのセッションの空いているスケジュールがどうしても見つからない場合は、 “空いているスケジュールがありません。'ボタンをクリックしてください。担当講師が別途セッションの日程を調整、または、弊社が再調整のサポートをいたします。',",
    myschedule_reschedule_next_instr3: "講師の変更",
    myschedule_reschedule_next_instr4a: "残りのセッションのうち１回またはそれ以上の回数で講師を変更するには、",
    myschedule_reschedule_next_instr4b: "お問い合わせフォーム",
    myschedule_reschedule_next_instr4c:
      "そして、{productname} + “講師の変更” をご選択ください。講師の変更を希望される理由をお教えください。",
    myschedule_rechedule_next_info:
      "再スケジュールおよび講師のキャンセル方法についてさらなる情報をご覧になりたい場合は",
    myschedule_rechedule_next_faq: "弊社のFAQポータルをご覧ください。　　　　　　　　　",
    myschedule_rechedule_next_noShow: "このインフォページを再度表示しない",
    myschedule_rechedule_next_done: "完了",
    myschedule_rechedule_skipButton: "スキップ",
    myschedule_upcoming_joinNow: "参加する",
    myschedule_cancel_question: "本当にこのレッスンをキャンセルされますか？",
    myschedule_cancel_button: "セッションのキャンセル",
    myschedule_cancel_no: "いいえ",
    myschedule_invalid_session: "申し訳ありません、このセッションは無効です。",
    myschedule_sessionDuraion_minutes: "分",
    myschedule_homepage_view: "表示する",
    myschedule_finished_status: "受講済",
    myschedule_reschedule_button: "再調整",
    myschedule_addToCalendar_instr1: "ダウンロードボタンをクリックすると、",
    myschedule_addToCalendar_instr2:
      "あなたのLearnshipスケジュールが表示されます。ダウンロードしたスケジュールは、ご自身のカレンダーに追加することができます。",
    myschedule_addToCalendar_instr3:
      "以前カレンダーにLearnshipスケジュールを追加したことがある場合は、はじめに既存のスケジュールを削除してください。",
    myschedule_addToCalendar_instr4: "カレンダーへのLearnshipスケジュールの追加方法詳細は",
    myschedule_addToCalendar_instr5: "こちらからご確認いただけます。",
    myschedule_no_teacher_title: "講師がアサインされていません",
    myschedule_no_teacher_body:
      "現在、セッションは追加いただけません（講師がアサインされていません）。プログラムを続けるには、coach@globalenglish.com までご連絡ください。",
    myschedule_no_sessions: "セッションが見つかりませんでした",
    myschedule_no_upcoming_sessions: "予定されているセッションはありません",
    myschedule_no_past_sessions: "過去のセッションはありません",
    myschedule_status_lost: "ロスト",
    myschedule_status_finished: "完了",
    myschedule_status_completed: "完了済み",
    myschedule_status_cancelled: "キャンセル済み",
    myschedule_status_inprogress: "実施中",
    myschedule_status_pending: "保留中",
    myschedule_status_active: "進行中",
    myschedule_status_inplanning: "調整中",

    // my schedule page translations end
    // Progress page
    progress_title: "学習の進捗状況",
    progress_activity_report: "活動報告",
    progress_test_results: "テスト結果",
    progress_productname_sprint_skills: "Sprint Business Skills",
    progress_productname_reach_skills: "Reachスキル",
    progress_skill_note: "終了証明書の発行にはコースワークおよびセッションの70%以上を完了する必要があります。",
    progress_overall_card_title_prework: "完了した準備演習",
    progress_overall_card_title_homework: "完了した宿題",
    progress_overall_card_title_session: "完了したセッション",
    progress_overall_card_title_certificate: "証書",
    progress_overall_card_title_skillsCompleted: "完了したスキル",
    progress_overall_card_title_badgesEarned: "獲得したバッジ",
    progress_overall_card_title_missionsPassed: "完了したミッション",
    progress_overall_card_title_timeInReach: "Reachにおける時間 (HH:MM)",
    progress_noSubskill: "表示するサブスキルはありません。",
    progress_tab_nodata: "こちらに表示するデータはありません。",
    progress_percentCompleted: "％ 完了",
    progress_subskill_preworkTitle: "予習",
    progress_subskill_homeworkTitle: "宿題",
    progress_subskill_sessionTitle: "セッション",
    progress_subskill_sessionStatusCompleted: "完了済",
    progress_subskill_sessionStatusNotCompleted: "完了していません",
    progress_subskill_sessionStatusNoSessions: "セッションはありません",
    progress_subskill_sessionNoDate: "N/A",
    progress_activity_tooltip_totaltime: "合計時間",
    progress_activity_tooltip_activitiesCompleted: "完了したアクティビティ",
    progress_activity_tooltip_reachMissionsCompleted: "完了したReachミッション",
    progress_activity_tooltip_timeinhhmm: "時間 (HH:MM)",
    progress_activity_tabDaily: "毎日",
    progress_activity_tabWeekly: "週単位",
    progress_activity_tabMonthly: "月単位",
    progress_activity_tabQuarterly: "四半期単位",
    progress_activity_tabQuarter: "四半期",
    progress_activity_tabYearly: "年単位",
    progress_acitivity_Minutes: "分",
    progress_acitivity_legend_selfpaced: "自分ペースの学習時間",
    progress_acitivity_legend_trainerLed: "講師指導の時間",
    progress_acitivity_legend_recommended: "おすすめ",
    progress_testresults_table_testname: "テスト名",
    progress_testresults_table_scores: "スコア",
    progress_testresults_table_date: "日付",
    progress_testresults_info: "あなたのテスト結果は 24 時間後に表示されます。",
    progress_inprogress: "実施中",
    progress_totalscore: "総合スコア",
    progress_placedText: "該当レベル",
    progress_button_viewscore: "View detailed report",
    progress_certificate_download_success: "Downloaded successfully",
    progress_partText: "Part",
    progress_emptyPartText: "Other",
    progress_overall_card_title_badge: "Badge",
    progress_badge_dialog_box_title: "修了証の取得には、デジタル演習の70％を完了する必要があります。",
    progress_badge_dialog_box_golden: "成功スコア80%には、ゴールドバッジが授与されます。",
    progress_badge_dialog_box_silver: "成功スコア70%～79%には、シルバーバッジが授与されます。",
    progress_badge_dialog_box_bronze: "成功スコア50%～69%には、ブロンズバッジが授与されます。",
    progerss_badge_dailog_box_digitalActivities:
      "成功スコアは、学習者のオンラインデジタルアクティビティでのパフォーマンスと参加度に基づいて計算されます。",
    progress_badge_dailog_box_liveSessions:
      "成功スコアは、学習者のオンラインデジタルアクティビティとライブセッションでのパフォーマンスと参加度に基づいて計算されます。",
    progress_elevate_dialog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with live sessions",

    //EO Progress page
    //email templates
    languageSelect: "Select a language",
    wcGroup1: "謝罪",
    wcGroup2: "苦情",
    wcGroup3: "賛辞",
    wcGroup4: "祝辞",
    wcGroup5: "文書",
    wcGroup6: "招待",
    wcGroup7: "求職",
    wcGroup8: "マーケティングと販売",
    wcGroup9: "会議",
    wcGroup10: "通知",
    wcGroup11: "注文",
    wcGroup12: "価格情報",
    wcGroup13: "要請",
    wcGroup14: "謝辞",
    wcTitle11: "プロジェクトの遅れに対する謝罪",
    wcTitle12: "アカウントのエラーに対する謝罪",
    wcTitle13: "出荷の遅れに対する謝罪",
    wcTitle14: "納入品が損傷していた場合の謝罪",
    wcTitle15: "会議に出席できなかった場合の謝罪",
    wcTitle21: "一般的な苦情",
    wcTitle22: "製品のトラブルに関する苦情",
    wcTitle23: "過剰請求に関する苦情",
    wcTitle31: "プロジェクトで活躍した同僚への賛辞",
    wcTitle32: "顧客サービスに関する賛辞",
    wcTitle33: "製品に関する賛辞",
    wcTitle41: "昇進に対する祝辞（フォーマルなもの）",
    wcTitle42: "昇進に対する祝辞（インフォーマルなもの）",
    wcTitle43: "個人的な出来事に関する祝辞",
    wcTitle51: "要請された書類の送付",
    wcTitle52: "注文書や発注書",
    wcTitle53: "請求書",
    wcTitle61: "社交イベントへの招待",
    wcTitle62: "ビジネスイベントへの招待",
    wcTitle63: "招待を受ける",
    wcTitle64: "招待を断る",
    wcTitle65: "ビジネスイベントを取り消す",
    wcTitle71: "願書の受領を知らせる",
    wcTitle81: "新製品の発表 ",
    wcTitle82: "新しい地域担当者の発表 ",
    wcTitle83: "新製品のデモ",
    wcTitle84: "請求先の変更",
    wcTitle85: "初回の販売会議後のフォローアップ",
    wcTitle86: "新規顧客を歓迎する",
    wcTitle87: "株主や顧客への年末（クリスマス）の挨拶",
    wcTitle91: "会議の日時を提案する",
    wcTitle92: "会議の日時を確認する",
    wcTitle93: "会議を延期する",
    wcTitle94: "会議の予定をキャンセルする",
    wcTitle95: "会議の内容を要約する",
    wcTitle101: "アカウントの停止",
    wcTitle102: "アカウント閉鎖の要請",
    wcTitle111: "注文受付の通知と注文内容の確認",
    wcTitle112: "出荷の通知",
    wcTitle113: "注文を取り消す",
    wcTitle114: "注文内容を変更する",
    wcTitle115: "注文品の受領を知らせる",
    wcTitle121: "価格情報を知らせる",
    wcTitle122: "見積額を受け入れる",
    wcTitle123: "見積額を却下する",
    wcTitle131: "詳細情報を要請する",
    wcTitle132: "製品に関する情報を要請する",
    wcTitle133: "サービスに関する情報を要請する",
    wcTitle141: "一般的な謝辞",
    Blob:
      "E メールテンプレートは、広範なビジネストピックに適用できます。 使用するテンプレートを選択し、お使いの E メールクライアントに直接エクスポートしてから内容を編集してください。",
    OpenInEmail: "E メールで開く",
    Quote1: "世界には現在 33 億もの E メールアカウントが存在します。",
    Quote1By: "Mashable",
    Quote2: "E メールは、他のチャンネルと比較するとほぼ 2 倍の利益を生み出しています。",
    Quote2By: "ダイレクトマーケティングリード",
    Quote3: "毎秒 350 万通の E メールが送信されています。",
    Quote3By: "マーケティングリード",
    SelectACategory: "カテゴリを選択してください",
    Title: "E メールテンプレート",
    WatchTutorial: "ビデオチュートリアルを視聴する",
    String: "見積もり１",
    //Culture Notes Dropdowns
    NoAm: "北米",
    Cenam: "中米",
    SoAm: "南米",
    EUR: "ヨーロッパ",
    ASIA: "アジア",
    CenASIA: "中央アジア",
    SoEASIA: "東南アジア",
    MidEAST: "中東",
    AFR: "アフリカ",
    AUST: "オーストラリア",
    Cana: "カナダ",
    Mexi: "メキシコ",
    Uniteds: "アメリカ合衆国",
    CostaR: "コスタリカ",
    DomRep: "ドミニカ共和国",
    Guate: "グァテマラ",
    Jama: "ジャマイカ",
    Panam: "パナマ",
    TriniTob: "トリニダード・トバゴ",
    Arge: "アルゼンチン",
    Braz: "ブラジル",
    Chil: "チリ",
    Vene: "ベネズエラ",
    Colomb: "コロンビア",
    Peru: "ペルー",
    Urug: "ウルグアイ",
    Austria: "オーストリア",
    Belg: "ベルギー",
    Bulg: "ブルガリア",
    Croatia: "クロアチア",
    Czec: "チェコ共和国",
    Denm: "デンマーク",
    Finl: "フィンランド",
    Fran: "フランス",
    Germ: "ドイツ",
    Greec: "ギリシャ",
    Hung: "ハンガリー",
    Icel: "アイスランド",
    Irel: "アイルランド",
    Ital: "イタリア",
    Lith: "リトアニア",
    Luxem: "ルクセンブルク",
    Neth: "オランダ",
    Norw: "ノルウェー",
    Pola: "ポーランド",
    Port: "ポルトガル",
    Roma: "ルーマニア",
    Russ: "ロシア連邦",
    Serb: "セルビア",
    Slovakia: "スロヴァキア",
    Slovania: "スロヴェニア",
    Spai: "スペイン",
    Swed: "スエーデン",
    Swit: "スイス",
    Turk: "トルコ",
    Ukra: "ウクライナ",
    Unitedk: "英国",
    Chin: "中国",
    Hong: "香港",
    Indi: "インド",
    Japa: "日本",
    Mongo: "モンゴル",
    Pakis: "パキスタン",
    SoKore: "韓国",
    SriLan: "スリランカ",
    Taiw: "台湾",
    Afgh: "アフガニスタン",
    Azer: "アゼルバイジャン",
    Kaza: "カザフスタン",
    Camb: "カンボジア",
    Indo: "インドネシア",
    Malay: "マレーシア",
    Phil: "フィリピン",
    Sing: "シンガポール",
    Thai: "タイ",
    Viet: "ベトナム",
    Bah: "バーレーン",
    Iran: "イラン",
    Iraq: "イラク",
    Isra: "イスラエル",
    Jor: "ヨルダン",
    Kuw: "クウェート",
    Leb: "レバノン",
    Oma: "オマーン",
    Qat: "カタール",
    SauArb: "サウジアラビア",
    UAE: "アラブ首長国連邦",
    Alger: "アルジェリア",
    Angol: "アンゴラ",
    Egyp: "エジプト",
    Ghana: "ガーナ",
    Guin: "ギニア",
    Keny: "ケニア",
    Malaw: "マラウイ",
    Moroc: "モロッコ",
    Mozam: "モザンビーク",
    Nige: "ナイジェリア",
    SoAfr: "南アフリカ",
    Tanz: "タンザニア",
    Ugan: "ウガンダ",
    Zamb: "ザンビア",
    Austra: "オーストラリア",
    NewZea: "ニュージーランド",
    //Culture Notes Dropdowns End
    culturenotes_mainintrotext:
      "受講者の皆様のビジネスとプロフェッショナルライフにとって重要な地域の文化を理解しましょう。",
    culturenotes_useculturalinfo:
      "様々な文化の情報を活用し、世界中のお客様や同僚との重要なミーティングに備えることができます。",
    culturenotes_topicfamiliarize: "営業時間、外食、贈答など異なる文化習慣に対する理解を深めましょう。",
    culturenotes_topiclearnculture:
      "慣習、文化の違い、地域ごとのマナーについて学び、文化的な間違いを起こさないようにしましょう。",
    culturenotes_tmaworldtext:
      "国別レポートは弊社のパートナーにより開発されました TMA World によって作成されています。PDF 形式でのダウンロードが可能です。",
    culturenoteslocation_viewbytopic: "トピック別に表示する",
    culturenoteslocation_viewbycountry: "国別に表示する",
    culurecenter_disclaimer_title: "免責事項",
    culturecenter_disclaimer:
      "こちらでお読みいただく情報は、新しい文化に慣れるための出発点としてお使いいただくよう作成されましたので、一般的なガイドとして扱ってください。このツールは、よく見られる文化的パターンについて学ぶのに役立ち、人々の行動、態度、反応における文化の違いをよりよく理解、解釈するためのフレームワークとしてご利用いただけます。しかし、重要な注意点として、特定の文化に共通する特徴は、地域や個人の性格によって異なりますことをご留意ください。",
    culturecenter_intercept_title: "異文化情報再開のお知らせ",
    culturecenter_intercept_text1: "ブラッシュアップを経て、異文化情報が再開されました。",
    culturecenter_intercept_text2:
      "異文化情報では、アメリカ、カナダ、メキシコ、中国、日本、インドなど、世界20カ国の国々におけるビジネス知識や習慣を学ぶことができます。​",
    culturecenter_intercept_direct: "異文化情報へ移動​",
    dailyNewsFeed_resources: "リメ[ス",
    dailyNewsFeed_daily_News: "デイリーニュースフィード",
    dailyNewsFeed_newsfeedoftheday: "今日のニュースフィード",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData:
      "申し訳ありませんが、ニュースフィードの取得ができません。しばらくしてから再度お試しください。",
    dailyNewsFeed_viewMoreCategories: "もっと見る",
    // Email templates end
    //Error Page Translations
    error_not_found: "ページが見つかりません。",
    error_contact_csm: "お手数ですが、カスタマーサクセスマネージャーにお問い合わせください。",
    error_under: "現在",
    error_maintenance: "メンテナンスを行っております",
    error_under_maintenance: "現在、当サイトは定期メンテナンスを行っております。",
    error_inconvenience: "ご迷惑をおかけいたしますが、ご了承ください。",
    error_tryagain: "しばらくしてから再度お試しください。",
    error_tryagainMins: "次の時間の後にお試しください",
    error_minutes: "分",
    error_hours: "時間",
    error_oops: "申し訳ありません。",
    error_permission_denied: "こちらのページへのアクセス許可がありません。",
    error_link_home: "ホームページ",
    error_contact_admin:
      "お手数ですが、<donottrans> Learnship </donottrans>のアドミニストレーターにお問い合わせください。",
    error_sorry: "申し訳ありません",
    error_load: "There was a problem loading this Page.",
    error_clear_cache:
      "お手数ですが、ブラウザのキャッシュを削除し、インターネット接続をご確認の上、再度お試しください。",
    error_contact: "お手数ですが、",
    error_contact_cst: "カスタマーサポートチームに",
    error_forhelp: "お問い合わせください。",
    error_having_trouble: "その他にもお困りのことがございますか。",
    //Accents and Dialects Dropdowns
    AF: "アフリカ",
    AS: "アジア",
    AU: "オーストラリア-オセアニア",
    CA: "カリブ",
    CE: "中米",
    EU: "ヨーロッパ",
    MI: "中東",
    NO: "北米",
    SO: "南米",
    CAMER: "カメルーン",
    EGYPT: "エジプト",
    ETHIO: "エチオピア",
    GHANA: "ガーナ",
    GUINE: "ギニア",
    NIGER: "ナイジェリア",
    SOUTH: "南アフリカ",
    TANZA: "タンザニア",
    AFGHA: "アフガニスタン",
    CHINA: "中国",
    INDIA: "インド",
    INDON: "インドネシア",
    JAPAN: "日本",
    KAZAK: "カザフスタン",
    LEBAN: "レバノン",
    MONGO: "モンゴル",
    NORTH: "北ベトナム",
    PAKIS: "パキスタン",
    PHILI: "フィリピン",
    SINGA: "シンガポール",
    KOREA: "韓国",
    SRI_L: "スリランカ",
    TAIWA: "台湾",
    THAIL: "タイ",
    TURKM: "トルクメニスタン",
    AUSTR: "オーストラリア",
    FIJI_: "フィジー",
    NEW_Z: "ニュージーランド",
    BERMU: "バミューダ",
    CUBA_: "キューバ",
    HAITI: "ハイチ",
    COSTA: "コスタリカ",
    GUATE: "グアテマラ",
    MARTI: "マルチニク（仏領）",
    TRINI: "トリニダードトバゴ",
    AUSTRI: "オーストリア",
    BELAR: "ベラルーシ",
    BELGI: "ベルギー",
    BULGA: "ブルガリア",
    CYPRU: "キプロス",
    CZECH: "チェコ共和国",
    DENMA: "デンマーク",
    ENGLA: "イングランド",
    FINLA: "フィンランド",
    FRANC: "フランス",
    GEORG: "グルジア",
    GERMA: "ドイツ",
    GREEC: "ギリシャ-ヘラス",
    HUNGA: "ハンガリー",
    IRELA: "アイルランド",
    ITALY: "イタリア",
    MACED: "北マケドニア",
    NETHE: "オランダ",
    NORTHI: "北アイルランド",
    POLAN: "ポーランド",
    ROMAN: "ルーマニア",
    RUSSI: "ロシア連邦",
    SCOTL: "スコットランド",
    SPAIN: "スペイン",
    SWEDE: "スエーデン",
    SWITZ: "スイス",
    TURKE: "トルコ",
    UKRAI: "ウクライナ",
    WALES: "ウェールズ",
    IRAN_: "イラン",
    IRAQ_: "イラク",
    ISRAE: "イスラエル",
    KUWAI: "クウェート",
    SAUDI: "サウジアラビア",
    SYRIA: "シリア",
    CANAD: "カナダ",
    MEXIC: "メキシコ",
    ARGEN: "アルゼンチン",
    BRAZI: "ブラジル",
    CHILE: "チリ",
    COLOM: "コロンビア",
    PARAG: "パラグアイ",
    PERU_: "ペルー",
    VENEZ: "ベネズエラ",
    RPTitle: "Rainbow passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "アクセントと方言",
    US: "アメリカ合衆国",
    ALABA: "アラバマ",
    ALASK: "アラスカ",
    ARKAN: "アーカンソー",
    CALIF: "カリフォルニア",
    FLORI: "フロリダ",
    GEORG_US: "ジョージア",
    HAWAI: "ハワイ",
    ILLIN: "イリノイ",
    INDIA_US: "インディアナ",
    KANSA: "カンザス",
    KENTU: "ケンタッキー",
    LOUIS: "ルイジアナ",
    MAINE: "メイン",
    MARYL: "メリーランド",
    MASSA: "マサチューセッツ",
    MICHI: "ミシガン",
    MINNE: "ミネソタ",
    MISSI: "ミシシッピ",
    MISSO: "ミズーリ",
    MONTA: "モンタナ",
    NEBRA: "ネブラスカ",
    NEW_H: "ニューハンプシャー",
    NEW_J: "ニュージャージー",
    NEW_Y: "ニューヨーク",
    NCARO: "ノースカロライナ",
    NDAKO: "ノースダコタ",
    OHIO_: "オハイオ",
    OKLAH: "オクラホマ",
    PENNS: "ペンシルベニア",
    SOUTH_US: "サウスカロライナ",
    TENNE: "テネシー",
    TEXAS: "テキサス",
    VIRGI: "バージニア",
    WEST_: "ウェストバージニア",
    WISCO: "ウィスコンシン州",
    //Accents and Dialects Dropdowns End
    manager_email_managertext:
      "貴社より管理者に、Learnshipでのあなたの進捗状況を示す月次レポートのリクエストがありました。あなたの管理者のEメールアドレスを以下にご入力ください。",
    // survey and notification
    notification_description_plural: "アンケート終了まであと {days} 日です。{date} までにご回答ください。",
    notification_description_singular: "アンケート終了まであと１日です。{date} までにご回答ください。",
    notification_maintenance_message: "Halo は {date} の {time}時にメインテナンスが予定されています。",
    //renewal
    renewal_welcome: "引き続き Learnship をご利用いただきましてありがとうございます。",
    renewal_text:
      "ご利用いただいております Learnship ライセンスは、{year}年{month}月{date}日 をもちまして期限切れとなります。 ライセンスを更新して、ビジネス英語のコミュニケーションスキルをさらに伸ばしましょう。 個別学習プランと今までの学習内容はすべて保存され、現在のレベルから継続してご利用いただけます。",
    renewal_later: "後で確認",
    renewal_affirmative: "ライセンスを更新します。",
    renewal_negative: "ライセンスを更新しません。",
    renewal_yes: "はい。",
    renewal_no: "いいえ。",
    courselevel: "コースレベル",
    currentunit: "現在のユニット",
    upcomingsession: "今後",
    viewschedule: "View Schedule",
    currentskills: "スキル",
    currentsubskills: "サブスキル",

    // TWT translations
    twt_talk_with_teacher_title: "英会話レッスン",
    twt_sub_heading: "オンラインクラスルームで、講師や他の学習者と、会話スキルを伸ばす練習をすることができます。",
    twt_select_sessions: "クラスを選択して下さい：",
    twt_view_schedule_title: "スケジュールを表示して、カレンダーに追加します",
    twt_next_week: "次の週",
    twt_previous_week: "前の週",
    twt_add_to_calendar: "カレンダーに追加",
    twt_view_more: "もっと見る",
    twt_topic: "トピック",
    twt_class_policy_title: "英会話レッスンのポリシーとガイドライン",
    twt_class_policy_subHeading:
      "本ポリシーは、英会話レッスン(Talk with the Teacher : TWT) を、教育的で且つ楽しめるものとなるように設定されています。ぜひご一読下さい。",
    twt_class_policy_list01:
      "1週間に1度※参加することができます。また、1クラスにつき、8名の受講者の参加が上限となっています。お勧め：セッションの開始直後に「今すぐ参加」のボタンを押して参加します。TWTクラスは、各セッションの最初の10分間のみ「今すぐ参加」のボタンが表示されます。例として、9:00開始のセッションの場合、「今すぐ参加」のボタンが表示されるのは9:10まで、且つ、該当のクラスが定員に達するまでです。その後は、このクラスへの参加はできなくなります。※ライセンスの種類により、週1回に制限されないものもあります。",
    twt_class_policy_list02_sub1: "クラスに入室したら、あなたの名前、都市、国、レベルをチャットに入力します。",
    twt_class_policy_list02_sub2: `例）"My name is Taro, and I'm from Tokyo, Japan. I'm in Level 6."`,
    twt_class_policy_list02_sub3: "インストラクターがマイクをアクティブにすると、マイクアイコンが表示されます。",
    twt_class_policy_list03:
      "音声の不具合など、技術的な問題がある場合は、カスタマーサポートへご連絡下さい。Learnship Oneの画面右上のヘルプ > カスタマーサポート から不具合内容を記入して送信するか、画面右下の吹き出しのマークから、カスタマーサポートへ チャット にてお知らせ下さい。尚、TWTの講師は、技術的な質問は受け付けておりません。",
    twt_class_policy_list04:
      "TWTには、4つのレベルが用意されています。初級、中級、上級そして全レベル対象の4つです。あなたの英語のレベルに合ったクラスへ参加します。例えば、レベル0-3の受講者は、初級クラスへ参加します。また、全ての受講者は、全レベル対象のクラス (Open Discussion) へ参加できます。自分のレベルに合っていないクラスに参加すると、講師からその旨を指摘されることがあります。その場合は、例えば、このレベルのクラスで今回は参加したいが、その代わりに発言はせずに聞くだけにすることを講師にお願いするか、または、このクラスを退室して、別の時間に自分に合ったレベルのクラスに参加します。",
    twt_class_policy_list05:
      "TWTでは、発言せずに聴くだけという方法でも参加できますが、聴くだけの参加は、1週間に1回、且つ1年に4回を上限として行うことができます。この上限を超えると、聴くだけでのTWTへの参加はできなくなります。次回以降は必ず、クラスで発言する必要があります。",
    twt_class_policy_list06:
      "攻撃的な言葉や他人を不快にさせる発言は、英語及びその他のいかなる言語においても謹んで下さい。この規則に反した者は、直ちにクラスから退室させることとします。また、必要に応じてこの者の上司に報告し、アカウントの削除を行うこととします。",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message:
      "You have already joined this session from another device. Please logout before joining from current device.",
    twt_max_capacity_error_message:
      "Sorry you cannot join this session because it has reached maximum capacity. Please join another session",
    twt_notification_message: "There's a conversation session starting right now. Do you want to join?",
    twt_limit_message: "今週はすでにクラスを受講済みです。",
    twt_session_unavailable: "No sessions available",
    twt_select_language: "Select language",

    //Vocabulary center translations
    vocab_center_product_headline: "Vocabulary center",
    vocab_center_search_word: "Search and add word",
    vocab_center_add_wordlist: "Add Word List",
    vocab_center_edit_wordlist: "Edit Word List",
    vocab_center_delete_wordlist: "Delete Word List",
    vocab_center_options_text: "Options",
    vocab_center_add_word: "Add Word",
    vocab_center_add_text: "Add",
    vocab_center_delete_wordlist_warning_message: "All the words under the list will be deleted. Click Yes to delete.",
    vocab_center_yes_text: "Yes",
    vocab_center_new_wordlist: "New Word List",
    vocab_center_created_wordlist_success_message: "You have successfully created your new word list",
    vocab_center_updated_wordlist_success_message: "You have successfully updated your word list",
    vocab_center_okay_text: "Okay",
    vocab_center_new_word_text: "New Word",
    vocab_center_enter_word_text: "Enter a word",
    vocab_center_word_exists_in_wordlist_warning_message: "This word already exists in this Word List",
    vocab_center_save_text: "Save",
    vocab_center_new_word_message: "This word does not exist. Do you want to create your own definition for the word ?",
    vocab_center_pos_label: "Part of speech",
    vocab_center_select_wordlist_text: "Select a word list",
    vocab_center_word_label: "Word",
    vocab_center_update_wordlist: "Update word list",
    vocab_center_definition_label: "Definition",
    vocab_center_translation_label: "Translation",
    vocab_center_sentence_label: "Sentence",
    vocab_center_note_label: "Note",
    vocab_center_cancel_text: "Cancel",
    vocab_center_delete_word_text: "Delete Word",
    vocab_center_delete_word_warning_message: "Are you sure you want to delete this word from the Word List ?",
    vocab_center_note_updated_message: "Your notes updated successfully!!",
    vocab_center_close_text: "Close",
    vocab_center_no_definition_text: "No definition available",
    vocab_center_no_translation_text: "No translation available",
    vocab_center_no_sentence_text: "No sentence available",
    vocab_center_no_note_text: "No notes added",
    vocab_center_word_save_message: "You have successfully saved the word in your word List",
    vocab_center_word_exists_error_message: "Selected word already exists in the same wordlist",
    vocab_center_submit_text: "Submit",
    vocab_center_delete_text: "Delete",
    vocab_center_edit_text: "Edit",
    vocab_center_no_word_message: "Oops! There are no words in your wordlist. Add new words!",
    vocab_center_no_wordlist_message: "Oops! There are no wordslist in {wordListName}. Add new wordslist!",
    vocab_center_enter_wordlist_text: "Enter a word list",
    vocab_center_feature_text:
      "Without grammar, Very little can be conveyed. Without vocabulary, nothing can be conveyed. - David Wilkins",

    // Stress and inotation translations
    stress_intonation_product_headline: "StressAndIntonation",
    stress_intonation_product_description:
      "Make your English more natural and easier to understand by learning how to use correct stress, rhythm, and intonation when you speak.",

    // Sounds of English translations
    soe_product_headline: "Sounds of English",
    soe_product_description: "Improve your communication skills by learning how to pronounce English sounds correctly.",
    soe_product_vowels: "Vowels",
    soe_product_consonants: "Consonants",
    soe_product_language_selection:
      "Select your language in the drop-down list to find the sounds that may be difficult for speakers of your language. Then select My Sounds to find the sounds that you had trouble with in the Pronunciation Practice and Communication Practice activities.",

    // Writing center
    wc_feature_headline: "ライティング センター",
    wc_feature_description: "Level up your professional writing ability via our targeted resources.",
    wc_feature_guideGroup1: "文章作成で陥りやすいミス",
    wc_feature_guideGroup2: "一般的なビジネスコミュニケーション",
    wc_feature_guideGroup3: "ビジネス書類",
    wc_feature_guideTitle11: "文章が不明確になる原因",
    wc_feature_guideTitle12: "ライティングにおける基本的な間違い",
    wc_feature_guideTitle13: "動詞の使い方",
    wc_feature_guideTitle21: "ビジネスコミュニケーションにおける「率直さ」",
    wc_feature_guideTitle22: "販売やマーケティングに関する表現",
    wc_feature_guideTitle23: "ビジネスでよく使われるイディオム",
    wc_feature_guideTitle31: "Eメールの効果的な書き方",
    wc_feature_guideTitle32: "プレゼン：一般的なヒント",
    wc_feature_guideTitle33: "プレゼン： 効果的な始め方",
  },
};
